import { lighten, makeStyles, useTheme } from '@material-ui/core/styles';

type StatusVariant = 'green' | 'red' | 'yellow';

const STATUS_VARIANT: Record<string, StatusVariant> = {
  completed: 'green',
  approved: 'green',
  unpaid: 'red',
  pending: 'red',
  refunded: 'yellow',
  'partially refunded': 'yellow',
  cancelled: 'red',
  superseded: 'yellow',
};

function getStatusVariant(status: string): StatusVariant {
  return STATUS_VARIANT[status?.toLowerCase()] ?? 'yellow';
}

const STATUS_VARIANT_STYLES: Record<StatusVariant, { bg: string; dot: string }> = {
  green: { bg: 'rgba(216, 255, 246, 1)', dot: '#10B981' },
  red: { bg: 'rgba(255, 241, 242, 1)', dot: '#EF4444' },
  yellow: { bg: 'rgba(255, 251, 235, 1)', dot: '#F59E0B' },
};

const useValuationStatusStyles = makeStyles(theme => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '50px',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
  },
  text: {
    fontSize: '12px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  textPrimary: {
    color: '#fff',
    fontSize: '12px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
}));

export const SubTypeChip = ({ label }: { label: string }) => {
  const classes = useValuationStatusStyles();
  return (
    <div className={classes.container} style={{ backgroundColor: 'rgba(226, 232, 240, 1)' }}>
      <span className={classes.text} style={{ color: '#475569' }}>{label}</span>
    </div>
  );
};

export const StatusChip = ({ status }: { status: string }) => {
  const classes = useValuationStatusStyles();
  const variant = getStatusVariant(status);
  const { bg, dot } = STATUS_VARIANT_STYLES[variant];
  return (
    <div className={classes.container} style={{ backgroundColor: bg }}>
      <div className={classes.dot} style={{ backgroundColor: dot }} />
      <span className={classes.text}>{status}</span>
    </div>
  );
};

export const PrimaryChip = () => {
  const classes = useValuationStatusStyles();
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  return (
    <div className={classes.container} style={{ backgroundColor: primaryColor }}>
      <div className={classes.dot} style={{ backgroundColor: lighten(primaryColor, 0.85) }} />
      <span className={classes.textPrimary}>Primary</span>
    </div>
  );
};
